import get from 'lodash/get'

export const getUserLocation = (state) => {
  let userLocation = get(state, 'user.location', {})

  return userLocation
}
